import type { ClockConfig, ClockState } from '@/types/sports/clock';

export const periodLabelFor = (
  state: ClockState,
  config: ClockConfig,
): { current: number; total: number; label: string } => {
  const { current, total } = state.period;

  if (current <= config.period_count) {
    return { current, total, label: config.period_label };
  }

  return {
    current: current - config.period_count,
    total: total - config.period_count,
    label: config.period_label === 'Half' ? 'Extra time' : 'Overtime',
  };
};
